import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './Styles/tokens.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

// /ui-kit — komponentlar ko'rgazmasi, faqat development rejimida.
// Production build'da bu shart false bo'ladi va UiKit kodi bundle'ga kirmaydi.
// Login/rol himoyasidan tashqarida, sidebar/header'siz ochiladi; production'da daraxt avvalgidek <App />.
const UiKit = process.env.NODE_ENV === 'development'
  ? React.lazy(() => import('./Pages/UiKit/UiKit'))
  : null;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <React.StrictMode>
      {UiKit ? (
        <Routes>
          <Route path="/ui-kit" element={<Suspense fallback={null}><UiKit /></Suspense>} />
          <Route path="*" element={<App />} />
        </Routes>
      ) : (
        <App />
      )}
    </React.StrictMode>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
